import {
    activateUserURL,
    assessmentrangedescurl,
    consentSms,
    deleteUserURL,
    downloadMultiPatientSummaryURL,
    fetchCPTCodesUrl,
    fetchProgramsURL,
    getAllRolesURL,
    getBillablePatientListURL,
    getDocumentsURL,
    getIcdCodesUrl,
    getInvoiceURL,
    getNotesForSupervisiorUrl,
    getPaymentsAtClinicLevelUrl,
    getSaasUserUrl,
    getUsersURL,
    insertassessmentrangedescurl,
    insertInvoicePaidAmountURL,
    insertMcqOrgClinicMapUrl,
    insertOrUpdateClinicLevelCPTCODESUrl,
    insertOrUpdateClinicLevelDSMCODESUrl,
    insertOrUpdateClinicLevelICDCODESUrl,
    insertOrUpdateUserRolesURL,
    insertSaasUsersAppointmentUrl,
    shareViaEmail,
    updateassessmentrangedescurl,
    updateSaasUSerOnBoardUrl,
    uploadDocumentURL,
    userClinicMapURL,
    userProgramMapURL,
    downloadReceiptUrl,
    userAssessmentMapUrl,
    getUserTypesURL,
    generatePasswordResetLinkURL,
} from "../../apiEndPoints"
import {
    axiosDelete,
    axiosGet,
    axiosPost,
    axiosPut,
} from "../../utilities/axiosRequest"
import { logTransaction } from "../appActions"

export function getDocuments(success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = getDocumentsURL + `?programId=${program.id}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetched documents successfully",
                            response
                        )
                    )
                } else {
                    failure("")
                    dispatch(logTransaction("Fetch documents failed", response))
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("Fetch documents Failed", err))
            })
    }
}

export function getCptCodes(success, failure, clinicId) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = fetchCPTCodesUrl
        if (clinicId) url += `?clinicId=${clinicId}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetched documents successfully",
                            response
                        )
                    )
                } else {
                    failure("")
                    dispatch(logTransaction("Fetch documents failed", response))
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("Fetch documents Failed", err))
            })
    }
}

export function insertOrUpdateClinicLevelCPTCODES(data, success, failure) {
    return function (dispatch) {
        let url = insertOrUpdateClinicLevelCPTCODESUrl

        axiosPost(url, data)
            .then(response => {
                if (
                    response.data.statusCD === 200 ||
                    response.data.statusCD === 400
                ) {
                    // alert(response.data.statusMSG)
                    console.log(
                        "response insertInvoice data.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("Insert invoice data", response))
                    success()
                } else {
                    dispatch(
                        logTransaction("Insert invoice data failure", response)
                    )
                    //alert("Payment failed")
                    failure(
                        response.data.statusMSG ||
                            "Failed to update the invoice"
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert  invoice data ", err))
                // alert("Payment failed")
                failure("Failed to update the invoice")
            })
    }
}

export function insertOrUpdateClinicLevelICDCODES(data, success, failure) {
    return function (dispatch) {
        let url = insertOrUpdateClinicLevelICDCODESUrl

        axiosPost(url, data)
            .then(response => {
                if (
                    response.data.statusCD === 200 ||
                    response.data.statusCD == 400
                ) {
                    success()
                } else {
                    failure(
                        response.data.statusMSG ||
                            "Failed to update the ICD Codes"
                    )
                }
            })
            .catch(err => {
                failure("Failed to update the ICD Codes")
            })
    }
}

export function insertOrUpdateClinicLevelDSMCODES(data, success, failure) {
    return function (dispatch) {
        let url = insertOrUpdateClinicLevelDSMCODESUrl

        axiosPost(url, data)
            .then(response => {
                if (response.data.statusCD === 200) {
                    success()
                } else {
                    failure(
                        response.data.statusMSG ||
                            "Failed to update the DSM Codes"
                    )
                }
            })
            .catch(err => {
                failure("Failed to update the DSM Codes")
            })
    }
}

export function insertMcqOrgClinicMap(data, success, failure) {
    return function (dispatch) {
        let url = insertMcqOrgClinicMapUrl

        axiosPost(url, data)
            .then(response => {
                // if (response.data.statusCD === 200) {
                success()
                // } else {
                //     failure(
                //         response.data.statusMSG ||
                //             "Failed to update the assessments"
                //     )
                // }
            })
            .catch(err => {
                failure("Failed to update the invoice")
            })
    }
}

export function getSaasUser(data, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = getSaasUserUrl
        // `?userName=${data.username}&passWord=${data.password}`
        axiosPost(url, {
            userName: data.username,
            password: data.password,
        })
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetched documents successfully",
                            response
                        )
                    )
                } else {
                    failure("")
                    dispatch(logTransaction("Fetch documents failed", response))
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("Fetch documents Failed", err))
            })
    }
}

export function bulkUploadDocuments(inputData, uploadSuccess, uploadFailure) {
    return function (dispatch, getState) {
        let program = getState().user?.program

        const formData = new FormData()
        formData.append("document", inputData.file)
        formData.append("title", inputData.title)
        formData.append("programId", program.id)
        inputData?.password && formData.append("password", inputData.password)

        axiosPost(`${uploadDocumentURL}`, formData, {
            "Content-Type": "multipart/form-data",
        })
            .then(response => {
                if (
                    response?.data?.statusCD === 200 &&
                    response?.data?.responseData
                ) {
                    uploadSuccess(response.data.responseData)
                } else if (
                    response.data.responseData == null &&
                    response.data.statusMSG == "Document already Exists"
                ) {
                    uploadFailure(response.data.statusMSG)
                } else {
                    uploadFailure(
                        response.data.statusMSG ||
                            "Failed to upload the document"
                    )
                }
                dispatch(logTransaction("Upload Documents", response))
            })
            .catch(err => {
                uploadFailure("Failed to upload the document")
                console.log(err, "Upload Documents Failed")
                dispatch(logTransaction("Upload Documents Failed", err))
            })
    }
}

export function fetchInvoice(data, state, success, failure) {
    return function (dispatch, getState) {
        let user = getState().login.user

        let url = getInvoiceURL
        let program = getState().user?.program
        url += `?isorg=${state}&programId=${program.id}`
        // url += isMaster ? "" : clinicId ? `&organizationId=${orgId}` : `&organizationId=${orgId}`

        if (data.hasOwnProperty("orgId")) {
            url += `&organizationId=${data.orgId}`
        }

        if (data.hasOwnProperty("clinicId")) {
            url += `&clinicId=${data.clinicId}`
        }
        // } else if (data.clinicId) {
        //     url += `&clinicId=${data.clinicId}`
        // }

        if (data.month) {
            url += `&month=${data.month}`
        }
        if (data.year) {
            url += `&year=${data.year}`
        }
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    if (response.data?.responseData) {
                        success(response.data.responseData)
                        dispatch(logTransaction("fetch invoice", response))
                    } else {
                        success([])
                        dispatch(
                            logTransaction("fetch invoice failed", response)
                        )
                    }
                } else {
                    failure(
                        response.data.statusMSG || "Failed to fetch invoices"
                    )
                }
            })
            .catch(err => {
                failure("Failed to fetch invoices")
                dispatch(logTransaction("fetch invoice failed", err))
            })
    }
}

export function fetchInvoiceWithId(invoiceId, success, failure) {
    return function (dispatch, getState) {
        let user = getState().login.user

        let url = getInvoiceURL
        url += `?isorg=${false}&id=${invoiceId}&programId=${1}`

        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    if (response.data?.responseData) {
                        success(response.data.responseData)
                        dispatch(logTransaction("fetch invoice", response))
                    } else {
                        success([])
                        dispatch(
                            logTransaction("fetch invoice failed", response)
                        )
                    }
                } else {
                    failure(
                        response.data.statusMSG || "Failed to fetch invoices"
                    )
                }
            })
            .catch(err => {
                failure("Failed to fetch invoices")
                dispatch(logTransaction("fetch invoice failed", err))
            })
    }
}

export function insertInvoice(data, success, failure) {
    return function (dispatch) {
        const { invoiceId, paidAmount, referenceNo, totalAmount, paymentDate } =
            data
        let url =
            insertInvoicePaidAmountURL +
            `?invoiceId=${invoiceId}&paidAmount=${paidAmount}&referenceNo=${referenceNo}&totalAmount=${totalAmount}&paymentDate=${paymentDate}`

        axiosPost(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    // alert(response.data.statusMSG)
                    console.log(
                        "response insertInvoice data.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("Insert invoice data", response))
                    success()
                } else {
                    dispatch(
                        logTransaction("Insert invoice data failure", response)
                    )
                    //alert("Payment failed")
                    failure(
                        response.data.statusMSG ||
                            "Failed to update the invoice"
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Insert  invoice data ", err))
                // alert("Payment failed")
                failure("Failed to update the invoice")
            })
    }
}

export function getBillablePatientList(data, state, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = getBillablePatientListURL + `?programId=${program.id}`
        // url += `?isorg=${state}`
        // url += isMaster ? "" : clinicId ? `&organizationId=${orgId}` : `&organizationId=${orgId}`

        if (data.hasOwnProperty("clinicId")) {
            url += `&clinicId=${data.clinicId}`
        }

        if (data.month) {
            url += `&month=${data.month}`
        }
        if (data.year) {
            url += `&year=${data.year}`
        }
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    if (response.data?.responseData) {
                        success(response.data.responseData)
                        dispatch(logTransaction("fetch invoice", response))
                    } else {
                        success([])
                        dispatch(
                            logTransaction("fetch invoice failed", response)
                        )
                    }
                } else {
                    failure(
                        response.data.statusMSG || "Failed to fetch invoices"
                    )
                }
            })
            .catch(err => {
                failure(err, "Failed to fetch invoices")
                dispatch(logTransaction("fetch invoice failed", err))
            })
    }
}

export function shareSummaryViaEmail(data, success, failure) {
    return function (dispatch, getState) {
        let url = shareViaEmail
        if (data.hasOwnProperty("email")) {
            url += `?email=${data.email}`
        }
        if (data.hasOwnProperty("month")) {
            url += `?month=${data.month}`
        }
        if (data.hasOwnProperty("year")) {
            url += `?year=${data.year}`
        }
        if (data.hasOwnProperty("clinicId")) {
            url += `?clinicId=${data.clinicId}`
        }
        axiosGet(url).then(response => {})
    }
}

export function downloadMultiPatientSummary(data, success, failure) {
    return function (dispatch, getState) {
        let program = getState().user?.program
        let url = downloadMultiPatientSummaryURL + `?programId=${program.id}`

        if (data.hasOwnProperty("patientId")) {
            url += `&patientId=${data.patientId}`
        }

        if (data.month) {
            url += `&month=${data.month}`
        }
        if (data.appointmentIds) {
            url += `&appointmentIds=${data.appointmentIds}`
        }
        if (data.year) {
            url += `&year=${data.year}`
        }
        if (data.sendToemail) {
            url += `&sendToemail=${data.sendToemail}`
        }
        ;(data.sendToemail ? axiosGet(url) : axiosGet(url, {}, {}, {}, "blob"))
            .then(response => {
                if (data.sendToemail) {
                    console.log(response, "saieuhfsiedfhncsehfci")
                    if (response.status === 200) {
                        success()
                    } else {
                        failure()
                    }
                    return
                } else {
                    const fileType = response.headers["content-type"]
                    const blob = new Blob([response.data], {
                        type: fileType,
                    })
                    // saveAs(blob, `billingSummary.${fileType.split("/")[1]}`)
                    // Create a FileReader to read the blob data for logging purposes
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        console.log("File content as text:", reader.result)
                    }
                    reader.readAsText(blob)

                    // Proceed with file download
                    const link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = `${data?.fileName}.${
                        fileType.split("/")[1]
                    }`
                    document.body.appendChild(link) // Append the link to the body
                    link.click()
                    document.body.removeChild(link) // Remove the link after clicking
                    success()
                }
            })
            .catch(error => {
                console.log(error, "saieuhfsiedfhncsehfci")
                failure()
            })
    }
}

export function getUsersCount(orgId, clinicId, category, success, failure) {
    return function (dispatch, getState) {
        console.log(orgId, clinicId, category, "ksdlkfjdslfjdfsflk")
        let user = getState().login?.user
        // let clinic =
        //   !clinicId
        //     ? user?.clinicListForUser?.[0]?.clinicId
        //     : clinicId
        // let organisation =
        //   !orgId
        //     ? user?.organizationListForUser &&
        //     user?.organizationlistforuser?.[0]?.organizationId
        //     : orgId

        let url = getUsersURL + "?isCount=true"
        // url += `&organizationId=${organisation}&clinicId=${clinic}`
        if (orgId) {
            url += `&organizationId=${orgId}`
        }
        if (clinicId) {
            url += `&clinicId=${clinicId}`
        }

        if (category) url += `&search=${category}`

        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    // alert(response.data.statusMSG)
                    console.log(
                        "get users reponse.......",
                        response.data.responseData
                    )
                    dispatch(
                        logTransaction("get users count success", response)
                    )
                    success(response.data.responseData)
                } else {
                    dispatch(
                        logTransaction("get users count failure", response)
                    )
                    //alert("Payment failed")
                    failure(
                        response.data.statusMSG || "Failed to fetch users count"
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("Failed to fetch users count", err))
                // alert("Payment failed")
                failure("Failed to fetch users count")
            })
    }
}

export function getUsers(
    orgId,
    clinicId,
    category,
    pageNo = 0,
    pageSize = 100,
    success,
    failure,
    userType
) {
    return function (dispatch, getState) {
        let user = getState().login?.user
        // let clinic =
        //   !clinicId
        //     ? user?.clinicListForUser?.[0]?.clinicId
        //     : clinicId
        // let organisation =
        //   !orgId
        //     ? user?.organizationListForUser &&
        //     user?.organizationlistforuser?.[0]?.organizationId
        //     : orgId

        let url = getUsersURL + `?pageNo=${pageNo}&pageSize=${pageSize}`
        // url += `?organizationId=${organisation}&clinicId=${clinic}&pageNo=${pageNo}&pageSize=${pageSize}`
        if (orgId) {
            url += `&organizationId=${orgId}`
        }
        if (clinicId) {
            url += `&clinicId=${clinicId}`
        }

        if (category) url += `&search=${category.toUpperCase()}`
        if (userType) url += `&userType=${userType}`

        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    // alert(response.data.statusMSG)
                    console.log("users response", response.data.responseData)
                    dispatch(logTransaction("Fetch users successful", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Failed to fetch users", response))
                    //alert("Payment failed")
                    failure(response.data.statusMSG || "Failed to fetch users")
                }
            })
            .catch(err => {
                dispatch(logTransaction("Failed to fetch users", err))
                // alert("Payment failed")
                failure("Failed to fetch users")
            })
    }
}

export function getAllRoles(
    orgId,
    clinicId,
    category,
    pageNo,
    pageSize,
    success,
    failure
) {
    return function (dispatch, getState) {
        let user = getState().login?.user
        // let organisation = !orgId
        //   ? user?.organizationListForUser &&
        //     user?.organizationlistforuser?.[0]?.organizationId
        //   : orgId

        let url = getAllRolesURL
        // url += `?organizationId=${organisation}&clinicId=${clinic}&pageNo=${pageNo}&pageSize=${pageSize}`
        // url += `?organizationId=${organisation}&pageNo=${pageNo}&pageSize=${pageSize}`

        if (category) url += `&searchCategory=${category.toUpperCase()}`

        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    // alert(response.data.statusMSG)
                    console.log("users response", response.data.responseData)
                    dispatch(logTransaction("Fetch roles successful", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Failed to fetch roles", response))
                    //alert("Payment failed")
                    failure(response.data.statusMSG || "Failed to fetch roles")
                }
            })
            .catch(err => {
                dispatch(logTransaction("Failed to fetch roles", err))
                // alert("Payment failed")
                failure && failure("Failed to fetch roles")
            })
    }
}

export function getAllRolesCount(orgId, clinicId, category, success, failure) {
    return function (dispatch, getState) {
        let user = getState().login?.user
        let clinic = !clinicId
            ? user?.clinicListForUser?.[0]?.clinicId
            : clinicId
        let organisation = !orgId
            ? user?.organizationListForUser &&
              user?.organizationlistforuser?.[0]?.organizationId
            : orgId

        let url = getAllRolesURL + "?isCount=true"
        // url += `&organizationId=${organisation}&clinicId=${clinic}`
        url += `&organizationId=${organisation}`

        if (category) url += `&searchCategory=${category}`

        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    // alert(response.data.statusMSG)
                    console.log("users response", response.data.responseData)
                    dispatch(logTransaction("Fetch roles successful", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("Failed to fetch roles", response))
                    //alert("Payment failed")
                    failure(response.data.statusMSG || "Failed to fetch roles")
                }
            })
            .catch(err => {
                dispatch(logTransaction("Failed to fetch roles", err))
                // alert("Payment failed")
                failure && failure("Failed to fetch roles")
            })
    }
}

export function insertOrUpdateUserRoles(data, success, error) {
    return function (dispatch, getState) {
        // dispatch(updateLoading(true));
        let user = getState().login.user
        let url = insertOrUpdateUserRolesURL
        // let userId = user?.profileForUser[0]?.userId
        let inputData = data

        // inputData.createdBy = userId

        console.log("input data user", JSON.stringify(inputData))
        axiosPost(url, inputData)
            .then(response => {
                if (response.data.statusCD == 200) {
                    dispatch(logTransaction("User Updated", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("User Updation error", response))
                    error(response.data.statusMSG)
                }
                // dispatch(updateLoading(false));
            })
            .catch(err => {
                dispatch(logTransaction("User Updation failure", err))
                // dispatch(updateLoading(false));
                error("")
                // error(err);
            })
    }
}

export function userClinicMap(data, success, error) {
    return function (dispatch, getState) {
        let url = userClinicMapURL
        if (data?.userId && data?.clinics)
            url += `?userId=${data.userId}&clinics=${data.clinics}`

        axiosPost(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    dispatch(
                        logTransaction("User map to clinics success", response)
                    )
                    success()
                } else {
                    dispatch(
                        logTransaction("User map to clinics error", response)
                    )
                    error(response.data.statusMSG)
                }
                // dispatch(updateLoading(false));
            })
            .catch(err => {
                dispatch(logTransaction("User map to clinics failure", err))
                // dispatch(updateLoading(false));
                error("")
                // error(err);
            })
    }
}

export function userProgramMap(data, success, error) {
    return function (dispatch, getState) {
        let url = userProgramMapURL
        if (data?.userId && data?.programs)
            url += `?userId=${data.userId}&programs=${data.programs}`

        axiosPost(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    dispatch(
                        logTransaction("User map to programs success", response)
                    )
                    success()
                } else {
                    dispatch(
                        logTransaction("User map to programs error", response)
                    )
                    error(response.data.statusMSG)
                }
                // dispatch(updateLoading(false));
            })
            .catch(err => {
                dispatch(logTransaction("User map to programs failure", err))
                // dispatch(updateLoading(false));
                error("")
                // error(err);
            })
    }
}

export function deleteUser(userId, success, error) {
    return function (dispatch, getState) {
        let url = deleteUserURL
        if (userId) url += `?userId=${userId}`

        axiosDelete(url)
            .then(response => {
                if (response.data.statusCD == 200) {
                    dispatch(logTransaction("User delete success", response))
                    success()
                } else {
                    dispatch(logTransaction("User delete error", response))
                    error(response.data.statusMSG)
                }
                // dispatch(updateLoading(false));
            })
            .catch(err => {
                dispatch(logTransaction("User delete failure", err))
                // dispatch(updateLoading(false));
                error("")
                // error(err);
            })
    }
}

export function activateUser(userId, success, failure) {
    return function (dispatch, getState) {
        let url = activateUserURL + `?userId=${userId}`
        axiosPut(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    console.log(
                        "response update notes.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("activate user success", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("activate user success", response))
                    failure(response)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Activate user Failure", err))
                failure(err.message)
            })
    }
}

export function updateSassUserOnboard(
    userName,
    success,
    failure,
    onBoarded = false
) {
    return function (dispatch, getState) {
        let { sassUser, organization } = getState().onboarding
        let { currentClinic: clinic } = getState().consultant
        console.log(organization, clinic, "dskljdsdlksfjkf")
        let url = updateSaasUSerOnBoardUrl
        //     `?userName=${
        //         userName || getState().onboarding.sassUser.userName
        //     }&orgId=${organization.organizationId}`
        // if (clinic?.clinicId) url += `&clinicId=${clinic.clinicId}`
        let body = {
            userName: sassUser.userName,
            clinicId: null,
        }
        if (organization?.organizationId)
            body.orgId = organization.organizationId
        if (clinic?.clinicId) body.clinicId = clinic.clinicId
        body.onBoarded = onBoarded
        axiosPut(url, body)
            .then(response => {
                if (response.data.statusCD === 200) {
                    console.log(
                        "response update notes.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("activate user success", response))
                    success(response.data.responseData)
                } else {
                    dispatch(logTransaction("activate user success", response))
                    failure(response)
                }
            })
            .catch(err => {
                dispatch(logTransaction("Activate user Failure", err))
                failure(err.message)
            })
    }
}

export function getAssessmentRangeDescriptions(
    id,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let url = assessmentrangedescurl + `?mcqCode=${id}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    success(
                        response.data.responseData?.filter(
                            desc => desc?.isActive
                        )
                    )
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure(err)
            })
    }
}

export function getICDCODES(id, success = () => {}, failure = () => {}) {
    return function (dispatch, getState) {
        let url = getIcdCodesUrl
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    success(
                        response.data.responseData?.filter(
                            desc => desc?.isActive
                        )
                    )
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure(err)
            })
    }
}

export function insertAssessmentRangeDescriptions(
    payload,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let url = insertassessmentrangedescurl
        axiosPost(url, payload)
            .then(response => {
                console.log(response, "aefckhbaefkcufdb")
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefckhbaefkcufdb")
                failure(err)
            })
    }
}

export function updateAssessmentRangeDescriptions(
    payload,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let url = updateassessmentrangedescurl + `/${payload.id}`
        axiosPut(url, payload)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefckhbaefkcufdb")
                failure(err)
            })
    }
}

export function fetchPrograms(success = () => {}, failure = () => {}) {
    return function (dispatch, getState) {
        let url = fetchProgramsURL
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    const programs = response?.data?.responseData
                        ? response.data.responseData.filter(
                              item => item.id !== 4
                          )
                        : []
                    success(programs)
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefckhbaefkcufdb")
                failure(err)
            })
    }
}

export function sendConsentSms(data, success = () => {}, failure = () => {}) {
    return function (dispatch, getState) {
        let url = consentSms + `?patientId=${data?.patientId}`
        if (data?.consent) url += `&consent=${data?.consent}`
        if (data?.date) url += `&date=${data?.date}`
        if (data?.reason) url += `&reason=${data?.reason}`
        axiosPost(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    const programs = response?.data?.responseData
                        ? response.data.responseData.filter(
                              item => item.id !== 4
                          )
                        : []
                    success(programs)
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefckhbaefkcufdb")
                failure(err)
            })
    }
}

export function insertSaasUsersAppointment(
    data,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let url = insertSaasUsersAppointmentUrl
        axiosPost(url, data)
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefckhbaefkcufdb")
                failure(err)
            })
    }
}

export function getPaymentsAtClinicLevel(
    data,
    success = () => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        const { clinicId, month, year } = data
        let url =
            getPaymentsAtClinicLevelUrl +
            `?clinicId=${clinicId}&month=${month}&year=${year}`
        axiosGet(url, data)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefckhbaefkcufdb")
                failure(err)
            })
    }
}

export function downloadReceipt(
    data,
    success = response => {},
    failure = () => {}
) {
    return function (dispatch, getState) {
        let url = downloadReceiptUrl
        if (data.appointment_ids && Array.isArray(data.appointment_ids)) {
            url += `?appointmentIds=${data.appointment_ids.join(",")}`
        } else {
            url += `?appointmentId=${data.appointment_id}`
        }

        axiosGet(url, data)
            .then(response => {
                if (response.status == 200) {
                    // console.log(response)
                    // const fileType = response.headers["content-type"]
                    // const blob = new Blob([response.data], {
                    //     type: fileType,
                    // })
                    // // saveAs(blob, `billingSummary.${fileType.split("/")[1]}`)
                    // // Create a FileReader to read the blob data for logging purposes
                    // const reader = new FileReader()
                    // reader.onloadend = () => {
                    //     console.log("File content as text:", reader.result)
                    // }
                    // reader.readAsText(blob)

                    // // Proceed with file download
                    // const link = document.createElement("a")
                    // link.href = window.URL.createObjectURL(blob)
                    // link.download = `${
                    //     data.patient_name + "_" + data.appointment_date
                    // }.${fileType.split("/")[1]}`
                    // document.body.appendChild(link) // Append the link to the body
                    // link.click()
                    // document.body.removeChild(link) // Remove the link after clicking
                    success(response.data.responseData)
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefckhbaefkcufdb")
                failure(err)
            })
    }
}
export function getNotesForSupervisiorCount(
    success = () => {},
    failure = () => {},
    orgId,
    clinicId
) {
    return function (dispatch, getState) {
        let url = getNotesForSupervisiorUrl + `?isCount=true`
        const searchFilter = getState().patients.searchFilter
        const filterData = {
            ...getState().patients.filterData,
            ...searchFilter,
        }
        const params = new URLSearchParams({
            isCount: "true",
            appointmentStatuses: 100490003,
        })

        if (filterData.hasOwnProperty("ehrPatientId")) {
            params.set("ehrPatientId", filterData.ehrPatientId)
        } else if (filterData.hasOwnProperty("searchByName")) {
            params.set("searchByName", filterData.searchByName)
        } else if (filterData.hasOwnProperty("email")) {
            params.set("email", filterData.email)
        } else if (filterData.hasOwnProperty("mobileNo")) {
            params.set("mobileNo", filterData.mobileNo)
        }

        // Final URL with all query parameters
        url = `${getNotesForSupervisiorUrl}?${params.toString()}`
        let user = getState().login?.user
        let clinic =
            clinicId === undefined || clinicId === ""
                ? user?.clinicListForUser?.[0]?.clinicId
                : clinicId
        let organisation =
            orgId === undefined || orgId === ""
                ? user?.organizationListForUser &&
                  user?.organizationlistforuser?.[0]?.organizationId
                : orgId
        url += `&clinicId=${clinic}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    if (Array.isArray(response?.data?.responseData)) {
                        success(
                            response.data.responseData.filter(
                                item =>
                                    !(item.claim_submitted && item.is_reviewed)
                            ).length || 0
                        )
                    } else {
                        success(0)
                    }
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefckhbaefkcufdb")
                failure(err)
            })
    }
}

export function getNotesForSupervisior(
    isInsurancePay,
    isNotesReviewed,
    page = 0,
    rowsPerPage = 10,
    success = () => {},
    failure = () => {},
    orgId,
    clinicId,
    month,
    year
) {
    return function (dispatch, getState) {
        console.log(month, year, "dsklfjldkjfldjflkds")
        let url =
            getNotesForSupervisiorUrl +
            `?pageNo=${page}&pageSize=${rowsPerPage}&appointmentStatuses=100490003`
        const searchFilter = getState().patients.searchFilter
        const filterData = {
            ...getState().patients.filterData,
            ...searchFilter,
        }
        const params = new URLSearchParams({
            pageNo: page,
            pageSize: rowsPerPage,
            appointmentStatuses: 100490003,
        })

        if (month) params.set("month", month)
        if (year) params.set("year", year)

        if (filterData.hasOwnProperty("ehrPatientId")) {
            params.set("ehrPatientId", filterData.ehrPatientId)
        } else if (filterData.hasOwnProperty("searchByName")) {
            params.set("searchByName", filterData.searchByName)
        } else if (filterData.hasOwnProperty("email")) {
            params.set("email", filterData.email)
        } else if (filterData.hasOwnProperty("mobileNo")) {
            params.set("mobileNo", filterData.mobileNo)
        }

        // Final URL with all query parameters
        url = `${getNotesForSupervisiorUrl}?${params.toString()}`

        console.log(
            isNotesReviewed,
            page,
            rowsPerPage,
            orgId,
            clinicId,
            month,
            year,
            "isNotesReviewed"
        )
        if (isNotesReviewed !== undefined && isNotesReviewed !== null) {
            url += `&isNotesReviewed=${isNotesReviewed}`
        }
        if (isInsurancePay !== undefined && isInsurancePay !== null) {
            url += `&isInsurancePay=${isInsurancePay}`
        }
        console.log(filterData, url, "dsklfjldkjfldjflkds")
        let user = getState().login?.user
        let clinic =
            clinicId === undefined || clinicId === ""
                ? user?.clinicListForUser?.[0]?.clinicId
                : clinicId
        let organisation =
            orgId === undefined || orgId === ""
                ? user?.organizationListForUser &&
                  user?.organizationListForUser?.[0]?.organizationId
                : orgId
        url += `&clinicId=${clinic}&organizationId=${organisation}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data?.responseData
                ) {
                    success(
                        response.data.responseData.filter(
                            item => !(item.claim_submitted && item.is_reviewed)
                        )
                    )
                } else {
                    failure()
                }
            })
            .catch(err => {
                console.log(err, "aefckhbaefkcufdb")
                failure(err)
            })
    }
}

export function userAssessmentMap(data, success, failure) {
    return function (dispatch) {
        let url = `${userAssessmentMapUrl}?userId=${data.userId}&mcqCodes=${data.mcqCodes}`

        axiosPost(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 ||
                    response.data.statusCD === 400
                ) {
                    // alert(response.data.statusMSG)
                    console.log(
                        "response userAssessmentMap data.......",
                        response.data.responseData
                    )
                    dispatch(logTransaction("userAssessmentMap data", response))
                    success()
                } else {
                    dispatch(
                        logTransaction("userAssessmentMap failure", response)
                    )
                    //alert("Payment failed")
                    failure(
                        response.data.statusMSG || "Failed to userAssessmentMap"
                    )
                }
            })
            .catch(err => {
                dispatch(logTransaction("userAssessmentMapa ", err))
                // alert("Payment failed")
                failure("Failed to userAssessmentMap")
            })
    }
}

export function fetchUserTypesAtClinicLevel(
    organizationId,
    clinicId,
    success,
    failure
) {
    return function (dispatch, getState) {
        let url =
            getUserTypesURL +
            `?organizationId=${organizationId}&clinicId=${clinicId}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(
                        logTransaction("fetch user types Success", response)
                    )
                    success(response.data.responseData)
                } else {
                    failure("Failed to fetch programs")
                    dispatch(
                        logTransaction("fetch user types failure", response)
                    )
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("fetch user types failure", err))
            })
    }
}

export function generatePasswordResetLink(data, success, failure) {
    return function (dispatch) {
        let url = `${generatePasswordResetLinkURL}?email=${data.email}&userId=${data.userId}&path=${data.path}`

        axiosPost(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 ||
                    response.data.statusCD === 400
                ) {
                    console.log(
                        "generatePasswordResetLink response...",
                        response.data.responseData
                    )

                    dispatch(
                        logTransaction(
                            "generatePasswordResetLink success",
                            response
                        )
                    )

                    success && success(response.data.responseData)
                } else {
                    console.log("generatePasswordResetLink failed")

                    dispatch(
                        logTransaction(
                            "generatePasswordResetLink failure",
                            response
                        )
                    )

                    failure &&
                        failure(
                            response.data.statusMSG ||
                                "Failed to generate password reset link"
                        )
                }
            })
            .catch(err => {
                console.log("generatePasswordResetLink error", err)

                dispatch(logTransaction("generatePasswordResetLink error", err))

                failure && failure("Failed to generate password reset link")
            })
    }
}
